import React, { useState } from "react";
import { Alert, Card, Col, Row } from "react-bootstrap";
import ModuleDisplayDateTime from "../../../../UI/modules/fieldsDisplay/ModuleDisplayDateTime";
import useConfirm from "../../../../../HOC/custom/useConfirm";

const Details = ({ item, members, detailsDispatch, loadItem, loading }) => {
  const { confirm } = useConfirm();

  return (
    <>
      <Row>
        <Col>
          <Card className="item mb-2">
            {loading && (
              <div className="overlay">
                <i className="fas fa-2x fa-sync-alt fa-spin"></i>
              </div>
            )}
            <Card.Header className="ps-1 pe-2 py-0">
              <Card.Title className="d-flex m-0 p-0">
                <div className="d-flex ImageSectionSpacing">
                  <div className="position-relative ms-2 mt-1 me-2">
                    <i
                      className={`fas fa-bell position-relative usericon`}
                      style={{ fontSize: "30px" }}
                    ></i>
                  </div>

                 <div className="d-flex flex-column align-content-center justify-content-center ms-1">
              <span className="m-0 text-bold text-custom-2">
                Send to - {item.to}{" "}
              </span>
              <span className="text-custom-4 mt-1 small text-bold">
                {item.type}
                <span className="text-custom-3 mt-1 ms-1 small">
                  ({item.admin?.firstName} {item.admin?.lastName})
                </span>
              </span>
            </div>
                </div>
              </Card.Title>

              <div className="card-tools">
                <div>
                  {item.importance === "Low" && (
                    <span className="badge badge-pill badge-custom-6 text-dark me-1">
                      Low Importance
                    </span>
                  )}
                  {item.importance === "Medium" && (
                    <span className="badge badge-pill  badge-custom-7 me-1">
                      Medium Importance
                    </span>
                  )}
                  {item.importance === "High" && (
                    <span className="badge badge-pill badge-custom-3 me-1">
                      High Importance
                    </span>
                  )}
                  {item.isProcessed === "1" && (
                    <span className="badge badge-pill badge-info me-1">
                      Completed
                    </span>
                  )}
                  {item.isProcessed === "0" && (
                    <span className="badge badge-pill badge-warning me-1">
                      Processing
                    </span>
                  )}
                  <span className="badge badge-light me-1 text-dark">
                    Send Date/Time :{" "}
                    <span className="text-secondary">
                      <ModuleDisplayDateTime value={item.createdAt} />{" "}
                    </span>
                  </span>
                </div>
              </div>
            </Card.Header>
            <Card.Body className="p-0 mb-0">
              {item.message && (
                <Alert className="alert-custom-3 m-1 px-1 py-0">
                  <span className="text-bold ">Message : </span>
                  {item.message}
                </Alert>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default Details;
